var generic = generic || {};
var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
var site = site || {};

site.template = site.template || {};

(function ($) {
  $(document).on('product:quickshopV2', function (e, args) {
    Drupal.behaviors.quickshopV2.launch(args, $(this));
  });
  $(document).on('grid.reflow', function () {
    Drupal.behaviors.quickshopV2.reinit($(this));
  });
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId) {
    $('.js-quickshop-link--v2', $(this)).data('skuBaseId', skuBaseId).attr('data-sku-base-id', skuBaseId);
  });
  $(document).on('product:quickshopV2_destroy', function () {
    Drupal.behaviors.quickshopV2.destroyQs($(this));
  });

  Drupal.behaviors.quickshopV2 = {
    attached: false,
    inlineQuickshop: Drupal.settings.product_display.inline_quickshop,
    itemsPerRow: 3,
    nodes: {},

    attach: function (context) {
      var self = this;
      var lastBP;

      if (this.attached) {
        return;
      }
      this.attached = true;
      self.isMobile = Unison.fetch.now().name === 'small';
      Unison.on('change', function (bp) {
        // Do nothing when toggling between large and medium.
        if (lastBP === 'large' && bp.name === 'medium' || lastBP === 'medium' && bp.name === 'large') {
          return;
        }
        lastBP = bp.name;
        self.isMobile = bp.name === 'small';
        self.reinit(context);
      });
      if (!self.isMobile || !self.inlineQuickshop) {
        // don't need to init the containers on mobile, we dont have QS on mobile
        self.init(context);
        self.getContainerNodes(context);
      }
    },

    getContainerNodes: function (context) {
      var self = this;

      self.nodes = {};
      var $grid = $();
      var $grids = $('.js-mpp-grid--quickshop, .js-product-grid--quickshop-v2', context);
      var isCarousel = false;
      var $pageContainers = $();
      var $containers = $();

      $grids.each(function () {
        $grid = $(this);
        isCarousel = $grid.hasClass('js-mpp-carousel') || $grid.hasClass('product-grid--carousel') || $grid.hasClass('mpp-grid--carousel');
        if (isCarousel) {
          $containers = $grid.siblings('.js-quickshop-container');
        } else {
          $containers = $grid.find('.js-quickshop-container');
        }
        if (!$containers.length) {
          $containers = $('.js-quickshop-container-parent', context).find('.js-quickshop-container');
        }
        if ($grid.hasClass('js-product-grid--quickshop-v2')) {
          $containers.addClass('quickshop-container-wrapper');
        }
        $pageContainers = $pageContainers.add($containers);
      });
      self.nodes.$containers = $pageContainers;
    },

    initGrid: function ($grids) {
      var self = this;

      // Insert quickshop placeholder divs into product grids.
      // On mobile there is a quickshop placeholder after each product thumb.
      // On desktop there's a shared one after each row of product thumbs.
      $grids.has('.js-mpp-grid-item').each(function () {
        var $grid = $(this);

        // First remove any existing quickshop wrappers in the grid.
        self.reset($grid);
        if (!$grid.data('itemsPerRow')) {
          $grid.data('itemsPerRow', self.itemsPerRow);
        }
        var classes = [];
        var rows = [];
        var isCarousel = $grid.hasClass('product-grid--carousel') || $grid.hasClass('mpp-grid--carousel');
        var $container = $('<div class="js-quickshop-container quickshop-container-wrapper" tabindex="-1" />');

        $container.data('itemsPerRow', $grid.data('itemsPerRow'));
        var $items = $('.js-mpp-grid-item', $grid);

        if (isCarousel) {
          $items.each(function () {
            var $gridItem = $(this);
            var className = self.buildClassName($gridItem.data('productId'), $gridItem.find('.product-thumb').data('sku-card-id'));

            classes.push(className);
          });
          // slick wraps our $items in its own stuff so we have to treat those
          // as items if they've been set.
          var $slides = $('.slick-slide', this);

          rows = $slides.length ? [$slides] : [$items];
          // only add if there is no other QS container
          if ($grid.next('.js-quickshop-container').length < 1) {
            $grid.after($container.clone()).next().addClass(classes.join(' '));
          }
        } else {
          $items = $items.filter(':visible');
          rows = self.addQSContainers(rows, $items, $container);
        }

        $grid.data('product-grid-rows', rows);
      });
    },

    buildClassName: function (productId, skuBaseId) {
      skuBaseId = !!skuBaseId ? '--' + skuBaseId : '';

      return 'js-quickshop-container--' + productId + skuBaseId;
    },

    addQSContainers: function (rows, $items, $container) {
      var self = this;
      var i = 0;
      var iLen = $items.length;
      var $row = $();
      var classes = [];
      var itemsPerRow = $container.data('itemsPerRow') || self.itemsPerRow;

      $items.each(function (index) {
        var $gridItem = $(this);
        var className = self.buildClassName($gridItem.data('productId'), $gridItem.find('.product-thumb').data('sku-card-id'));

        classes.push(className);

        if (self.isMobile) {
          // For mobile simply add the quickshop wrapper immediately following
          // the item:
          $gridItem.after($container.clone()).next().addClass(classes.join(' '));
          classes = [];
          rows.push($gridItem);
        } else {
          // For desktop add a new wrapper after every row of 3 items:
          var span = 1;

          if ($gridItem.data('colspan')) {
            span = $gridItem.data('colspan');
          }
          i += span;
          $row = $row.add(this);
          if (i === itemsPerRow || index + 1 === iLen) {
            $gridItem.addClass('last'); // css targets this rather than nth-of-type
            $gridItem.after($container.clone()).next().addClass(classes.join(' '));
            rows.push($row);
            i = 0;
            $row = $();
            classes = [];
          }
        }
      });

      return rows;
    },

    destroyQs: function () {
      var self = this;

      if (!!self.nodes.$containers && self.nodes.$containers.length > 0) {
        self.nodes.$containers.remove();
      }
    },

    reset: function ($grid) {
      var $container = $grid.hasClass('product-grid--carousel') ? $grid.parent() : $grid;

      $('.js-quickshop-container', $container).remove();
    },

    getRelatedDomNodes: function (args) {
      var self = this;
      var nodes = {};
      var $container = $();
      var currentIndex = 1;
      var skuBaseId;
      var isCarousel;
      var gridItemSelector;

      nodes.$qsBtn = args.$ele;

      if (self.inlineQuickshop) {
        isCarousel = !!nodes.$qsBtn.closest('.slick-initialized').length;
        gridItemSelector = isCarousel ? '.slick-slide:not(.js-product-brief-shades-item)' : '.js-mpp-grid-item';
        nodes.$gridItem = nodes.$qsBtn.closest(gridItemSelector);
        nodes.$gridItems = nodes.$gridItem.parent().find(gridItemSelector);
        skuBaseId = nodes.$qsBtn.closest('.product-thumb').data('sku-card-id');
        $container = self.nodes.$containers.filter('.js-quickshop-container--' + args.product.PRODUCT_ID);
        if (!!skuBaseId) {
          $container = self.nodes.$containers.filter('.js-quickshop-container--' + args.product.PRODUCT_ID + '--' + skuBaseId);
        }
        nodes.$container = $container;
        currentIndex = self.getCurrentIndex(nodes, isCarousel);
        $container.data('openedQs', currentIndex).attr('data-opened-qs', currentIndex);
      }

      return nodes;
    },

    getCurrentIndex: function (nodes, isCarousel) {
      var self = this;
      var i = 0;
      var itemsPerRow = nodes.$container.data('itemsPerRow') || self.itemsPerRow;
      var $activeSlides = nodes.$gridItems.filter('.slick-active');

      if (isCarousel) {
        i = (($activeSlides.index(nodes.$gridItem) + 1) % itemsPerRow) || itemsPerRow;
      } else {
        i = nodes.$gridItem.prevUntil('.js-quickshop-container').length + 1;
      }

      return i;
    },

    getTemplate: function () {
      var template = 'product_quickshop_v2';

      if (!site.templates.hasOwnProperty(template)) {
        for (var templ in site.templates) {
          if (templ.match(/quickshop(_\w+)?_v(\d+)/)) {
            template = templ;
            break;
          }
        }
      }

      return template;
    },

    availableSkus: function (availableSkusString, product) {
      var skus = [];

      _.each(_.map(availableSkusString.split(','), $.trim), function (skuID) {
        _.each(product.skus, function (sku) {
          if (sku.SKU_ID === skuID) {
            skus.push(sku);
          }
        });
      });
      if (skus.length) {
        product.skus = skus;
      }

      return product;
    },

    triggerOldQS: function (args, context) {
      var self = this;

      if (self.isMobile && !args.$ele.hasClass('js-redesign')) {
        $(document).trigger('product:quickshop', args);
        $('.js-quickshop__container', context).focus();

        return true;
      }

      return false;
    },

    launch: function (args, context) {
      var self = this;

      if (self.triggerOldQS(args, context)) {
        return;
      }
      var skuBaseId = args.$ele.data('skuBaseId');

      if (typeof skuBaseId === 'undefined') {
        skuBaseId = prodcat.ui.getSkuIdByProduct(args.$ele);
      }
      var nodes = self.getRelatedDomNodes(args);
      var $container;
      var $activeContainers;
      var template = self.getTemplate();
      var availableSkusString = nodes.$qsBtn.data('available-skus');
      // We're potentially about to remove some skus, so avoid doing it by
      // reference.
      var product = jQuery.extend(true, {}, args.product);
      var defaultSkuId = product.defaultSku.SKU_ID;

      if (availableSkusString) {
        // If the product has data-available-skus set that means to only display the
        // skus available in that attribute.
        product = self.availableSkus(availableSkusString, product);
        // Set first available sku as default if the default product sku was excluded.
        if (!availableSkusString.includes(defaultSkuId) && product.skus[0]) {
          product.defaultSku = product.skus[0];
          skuBaseId = product.skus[0].SKU_BASE_ID;
        }
      }
      product['defaultImageField'] = Drupal.settings.product_display.quickshop_default_image_field;
      if (product['defaultImageField']) {
        product.skus[0]['defaultImage'] = product.skus[0][product['defaultImageField']];
      }

      // Render quickshop
      var rendered = site.template.get({
        name: template,
        data: { 'product': product }
      });

      // Populate and show the container we're activating
      if (self.inlineQuickshop) {
        $container = nodes.$container;
        $activeContainers = self.nodes.$containers.filter('.active');

        $activeContainers.hide();
        $container.html(rendered);

        $container.trigger('product:quickshop:available');
        self.productInit($container);
        $container.find('.js-product').trigger('product.skuSelect', skuBaseId);

        $container.show();
        self.animateQuickshop(nodes);
        self.fireQStagging(args);
        self.setQSEvents(nodes);
      } else {
        generic.overlay.launch({
          'content': rendered,
          height: 'auto',
          width: 1000,
          maxWidth: '100%',
          cssClass: 'qs-overlay-cbox js-quickshop-container',
          onComplete: function () {
            var $cbox = $('#colorbox.qs-overlay-cbox');
            var resizeFn = _.debounce(function () {
              $.colorbox.resize();
            }, 400);

            // Resize initially to get rid of the full background
            $.colorbox.resize();
            // Resize delayed by 200 to account for cached images
            resizeFn();
            // Resize on resize and image load
            $(window).on('resize.quickshop', resizeFn);
            $cbox.find('img').on('load', resizeFn);

            $('.selectBox').selectBox();
            // Trigger event and pass current overlay
            $(document).trigger('quickshop.loaded', $cbox);
            $(document).on('addToCart.success', function () {
              $.colorbox.close();
            });

            $cbox.trigger('product:quickshop:available');
            self.productInit($cbox);
            $cbox.find('.js-product').trigger('product.skuSelect', skuBaseId);

            $cbox.show();

            self.fireQStagging(args);
          }
        });
      }
    },

    productInit: function ($container) {
      $container.trigger('products.init-start');
      prodcat.ui.init($container);
      $container.find('.js-product').trigger('product.init');
      $container.trigger('products.init-finish');
    },

    fireQStagging: function (args) {
      // fire QV tagging event
      if (typeof window.CATEGORY_ID != 'undefined' && typeof args.product.PRODUCT_ID != 'undefined') {
        var QV_prod_id = window.CATEGORY_ID + '~' + args.product.PRODUCT_ID;

        $(window).trigger('MPP:productQV', [QV_prod_id]);
      }
    },
    setQSEvents: function (nodes) {
      var self = this;
      // Events for close button click / keydown
      var $closeButton = $('.js-quickshop-close', nodes.$container);

      $closeButton.once().on('keydown.quickShop', function (e) {
        if (site.getKeycode(e) === 13) {
          e.preventDefault();
          $(this).trigger('click');
          $('.js-quickshop-link.js-quickshop-trigger').removeClass('hideqs').focus();
        }
      }).on('click.quickShop', function (e) {
        e.preventDefault();
        self.closeQS(nodes);
        $('.js-quickshop-trigger.hideqs').attr('aria-expanded', 'false').focus();
      });
    },

    closeQS: function (nodes) {
      var self = this;
      var defaultSpeed = 400;

      nodes.$qsBtn.removeClass('active');
      nodes.$container.slideUp(defaultSpeed, function () {
        self.removeClassRegex($(this), 'active').empty();
      });
    },

    removeClassRegex: function ($elem, str) {
      $elem.removeClass(function (index, className) {
        return (className.match(new RegExp('\\S*' + str + '\\S*', 'g')) || []).join(' ');
      });

      return $elem;
    },

    animateQuickshop: function (nodes) {
      var self = this;
      var speed = 400;
      var currentIndex = nodes.$container.data('openedQs');

      // 1. If current quickshop is already active, no need to animate anything
      if (nodes.$container.hasClass('active')) {
        self.removeClassRegex(nodes.$container, 'active--').addClass('active--' + currentIndex);

        return;
      }

      // 2. If there are other active quickshops, clear the active classes from them
      self.removeClassRegex(self.nodes.$containers.filter('.active'), 'active').empty();

      // 3. Hide quickshop and animate it open
      nodes.$container.focus().addClass('active active--' + currentIndex).hide().slideDown(speed);

      var qt = nodes.$container.offset().top || 0;
      var qo = -200;

      // Scroll animation:
      $('html, body').animate({
        scrollTop: qt + qo
      }, {
        duration: speed
      });
    },

    init: function (context) {
      var self = this;
      var $grids = $('.js-mpp-grid--quickshop', context);
      var size = Unison.fetch.now() ? Unison.fetch.now().name : 'medium';

      self.initGrid($grids, size);
    },

    reinit: function (context) {
      var self = this;

      if (!self.isMobile || !self.inlineQuickshop) {
        self.init();
        // need to reload the Containers when mixitup ends loading
        self.getContainerNodes(context);
      }
    }
  };
})(jQuery);
